/*
 * ************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *   Copyright 2019 Adobe Systems Incorporated
 *   All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 * ************************************************************************
 */

import { connect } from '@airglow/store-redux';
import SessionDetailsModal from '../../ui/session-view/session.details.modal';

import {
  selectActiveSessionLink,
  selectActiveSessionToken
} from '../../common/selectors';
import { detailsForm } from '../data/form.prefabs';
import { showDetails } from '../data/prefabs';

const mapState = state => ({
  detailsForm: { dirty: detailsForm.isDirty(state) },
  link: selectActiveSessionLink(detailsForm, state),
  pin: selectActiveSessionToken(state),
  open: showDetails.isOn(state),
  ...detailsForm.state(state)
});

const mapHandlers = (dispatch) => {
  const { onSubmit, onReset, ...others } = detailsForm.handlers(dispatch);

  return ({
    detailsForm: {
      onReset,
      onSubmit
    },
    onClose: () => {
      showDetails.doClose(dispatch);
    },
    ...others
  });
};

export default connect(mapState, mapHandlers)(SessionDetailsModal);
